"use client";

import { useEffect, useState } from "react";
import style from "./style.module.scss";
import Image from "next/image";
import { APP_STORE_URL, GOOGLE_PLAY_URL, GENERAL, UI_TEXT, IMAGE_PATHS } from "@/constants";
import Message from "./Message";
import Markets from "../markets";


const DownloadPopup = ({ onClose }: { onClose: () => void }) => {
  const [isClosing, setIsClosing] = useState(false);
  const [isOpening, setIsOpening] = useState(false);

  useEffect(() => {
    requestAnimationFrame(() => {
      setIsOpening(true);
    });
  }, []);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      onClose();
    }, GENERAL.POPUP_CLOSE_ANIMATION_DELAY);
  };

  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  const handleContainerClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
  };

  return (
    <div className={style.popupWrapper} onClick={handleBackdropClick}>
      <div
        className={`${style.popupContainer} ${isClosing ? style.closing : isOpening ? style.opening : ''}`}
        onClick={handleContainerClick}
      >
        <Image
          className={style.closeButton}
          src={IMAGE_PATHS.ICONS.CLOSE}
          alt="close"
          width={GENERAL.IMAGE_SIZES.EXTRA_LARGE}
          height={GENERAL.IMAGE_SIZES.EXTRA_LARGE}
          onClick={handleClose}
        />
        <Image className={style.popupImage} src={IMAGE_PATHS.POPUP.DOWNLOAD_IMAGE} alt="download-popup" width={0} height={0} />
        <div className={style.popupContent}>
          <Image src={IMAGE_PATHS.LOGOS.AVIATION_LOGO} alt="markets" width={GENERAL.IMAGE_SIZES.LOGO_LARGE_WIDTH} height={GENERAL.IMAGE_SIZES.LOGO_LARGE_HEIGHT} />
          <div className={style.titleContainer}>
            <h2 className={style.title}>{UI_TEXT.POPUP.DOWNLOAD_TITLE}</h2>
            <p className={style.description}>{UI_TEXT.POPUP.DOWNLOAD_DESCRIPTION}</p>
          </div>
          <Image className={style.popupImageMobile} src={IMAGE_PATHS.POPUP.DOWNLOAD_IMAGE_MOBILE} alt="download-popup" width={0} height={0} />
          <div className={style.featuresContainer}>
            <Message position="left" message={UI_TEXT.MESSAGES.ACCESS_LIVE_DATA} />
            <Message position="right" message={UI_TEXT.MESSAGES.OPTIMIZE_ROUTE} />
            <Message position="left" message={UI_TEXT.MESSAGES.STAY_FLIGHT_READY} />
            <Message position="right" message={UI_TEXT.MESSAGES.MONITOR_ATIS} />
          </div>
          <div className={style.marketsWrapper}>
            <Markets height={38} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DownloadPopup;


